// Import Toastify only in stand alone
import 'react-toastify/dist/ReactToastify.css';

import('./views/Playground/bootstrap');

export {};
